import React from 'react'
import {useI18n} from '../../../../../../Utils/_helpers/useI18n'

type WaitForReplySidebarProps = {
  value: number
  onChange: (value: number) => void
}

const WaitForReplySidebar: React.FC<WaitForReplySidebarProps> = ({value, onChange}) => {
  const {t} = useI18n()

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const next = Number(event.target.value || 0)
    if (Number.isNaN(next) || next <= 0) {
      onChange(1)
      return
    }
    onChange(next)
  }

  return (
    <div className='d-flex flex-column gap-3'>
      <div>
        <h5 className='mb-1'>{t('FLOW.NODE.WAIT_FOR_REPLY')}</h5>
        <p className='text-muted small mb-0'>
          {t('FLOW.SIDEBAR.WAIT_FOR_REPLY_DESC')}
        </p>
      </div>

      <div className='mb-2'>
        <label htmlFor='waitForReplyWindow' className='form-label fw-semibold'>
          {t('FLOW.SIDEBAR.WAIT_FOR_REPLY_WINDOW_LABEL')}
        </label>
        <div className='input-group'>
          <input
            id='waitForReplyWindow'
            type='number'
            min={1}
            className='form-control'
            value={value}
            onChange={handleChange}
          />
          <span className='input-group-text'>
            {t('FLOW.SIDEBAR.WAIT_FOR_REPLY_WINDOW_SUFFIX')}
          </span>
        </div>
        <div className='form-text'>
          {t('FLOW.SIDEBAR.WAIT_FOR_REPLY_WINDOW_HELP')}
        </div>
      </div>
    </div>
  )
}

export default WaitForReplySidebar

